/** Site defaults and the Cookiebot consent categories. */
const toBoolean = (value) => value === true || value === 'true';

export const DENIED_CONSENT = Object.freeze({preferences: false, statistics: false, marketing: false});

export const getCookiebotConfig = (site, locale) => {
  const preferences = site?.preferences || {};
  const domainGroupId = String(preferences.cookiebotDomainGroupId || '').trim();

  return {
    enabled: toBoolean(preferences.cookiebotEnabled),
    domainGroupId,
    valid: /^[a-f\d]{8}(?:-[a-f\d]{4}){3}-[a-f\d]{12}$/i.test(domainGroupId),
    culture: String(locale?.id || 'en').split('-')[0].toLowerCase(),
  };
};

export const getDefaultDnt = (site) => {
  // Only an explicit false enables tracking by default without a notice.
  // Missing configuration stays denied until the site's policy is configured.
  const preference = site?.preferences?.cookiebotEnabled;

  return preference !== false && preference !== 'false';
};

export const getCookiebotConsent = (cookiebot) => ({
  preferences: cookiebot?.consent?.preferences === true,
  statistics: cookiebot?.consent?.statistics === true,
  marketing: cookiebot?.consent?.marketing === true,
});

export const getConsentWithoutCookiebot = (site, effectiveDnt) => {
  const granted = effectiveDnt === false && !getDefaultDnt(site);
  const consent = {preferences: granted, statistics: granted, marketing: granted};

  // Preserve old Google opt-outs during migration. These do not set SFCC DNT.
  try {
    const previous = JSON.parse(window.localStorage.getItem(`kl_gtm_cmp_consent_${site.id}`));

    if (previous?.analytics === false) consent.statistics = false;
    if (previous?.marketing === false) consent.marketing = false;
  } catch {
    // Storage can be unavailable; the SDK DNT preference still applies.
  }

  return consent;
};

export const applyPrivacySignal = (consent) => ({
  ...consent,
  marketing: consent.marketing && !(typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true),
});
